import React, { useState } from "react";
import BorgStyleTextField from "./BorgStyleTextField";
import BorgStyleButton from "./BorgStyleButton";

interface PasswordResetFormProps {
    resetEmail: string;
    setResetEmail: (email: string) => void;
    resetMessage: string;
    resetError: string;
    handlePasswordReset: () => void;
    onBackToLogin: () => void;
    isLoading?: boolean;
}

const PasswordResetForm: React.FC<PasswordResetFormProps> = ({
    resetEmail,
    setResetEmail,
    resetMessage,
    resetError,
    handlePasswordReset,
    onBackToLogin,
    isLoading = false,
}) => {
    return (
        <div className="box-column">
            <BorgStyleTextField
                id="textbox-email"
                label="Enter Email"
                value={resetEmail}
                type="text"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setResetEmail(e.target.value)}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter" && !isLoading) {
                        handlePasswordReset();
                    }
                }}
            />
            <BorgStyleButton 
                id="button-submit" 
                onClick={handlePasswordReset}
                disabled={isLoading}
            >
                {isLoading ? "Sending..." : "Send Reset Link"}
            </BorgStyleButton>

            <button
                onClick={onBackToLogin}
                disabled={isLoading}
                style={{ 
                    marginTop: 10, 
                    background: "none", 
                    border: "none", 
                    color: isLoading ? "#888" : "#fcbf49", 
                    cursor: isLoading ? "not-allowed" : "pointer" 
                }}
            >
                Back to Login
            </button>
            {isLoading && (
                <div style={{ color: "#fcbf49", textAlign: "center", margin: "10px 0" }}>
                    Processing your request...
                </div>
            )}
            {resetMessage && <p style={{ color: "green" }}>{resetMessage}</p>}
            {resetError && <p style={{ color: "red" }}>{resetError}</p>}
        </div>
    );
};

export default PasswordResetForm;
